export const maleOnlyTag = 'male-only'
export const femaleOnlyTag = 'female-only'

// Public nodes stating who the user is rather than something measured about
// them, so rules about a measurement (optimal state, timeframe) don't apply.
export const PROFILE_NODE_NAMES: readonly string[] = ['Sex', 'Age']

// Public nodes with no healthier state to steer the user towards. Pregnancy is
// not a profile node: it changes over time, so it keeps its timeframe.
export const NO_OPTIMAL_STATE_NODE_NAMES: readonly string[] = [
  ...PROFILE_NODE_NAMES,
  'Pregnancy',
]
